module.exports = {
	"Search the video": "वीडियो को खोजें",
	"Explore": "एक्सप्लोर करें",
	"Print": "प्रिंट करें",
	"Download": "डाउनलोड करें",
	"Share": "शेयर करें",
	"Settings": "सेटिंग्स",
	"Language": "भाषा",
	"Interface Language": "इंटरफेस भाषा",
	"Transcript / Captions Language": "ट्रांसक्रिप्ट/ कैप्शन्स भाषा",
	"Transcript Language": "ट्रांसक्रिप्ट भाषा",
	"Captions Language": "कैप्शन्स भाषा",
	"Show Transcript": "ट्रांसक्रिप्ट दिखाएं",
	"Show Captions": "कैप्शन्स दिखाएं",
	"Show Heatmap": "हीटमैप दिखाएं",
	"Show Speakers in Transcript": "ट्रांसक्रिप्ट में स्पीकर्स दिखाएं",
	"Keyword": "कीवर्ड",
	"Keywords": "कीवर्ड्स",
	"Topic": "विषय",
	"Topics": "विषयों",
	"Speaker": "स्पीकर",
	"Speakers": "स्पीकर्स",
	"Transcript": "ट्रांसक्रिप्ट",
	"Previous": "पिछला",
	"Next": "अगला",
	"Clear": "हटाएं",
	"No results found": "कोई परिणाम नहीं मिले",
	"try another search or explore": "कुछ और खोजें या एक्सप्लोर करें",
	"Share Search": "खोज शेयर करें",
	"Share Time": "समय शेयर करें",
	"There is no transcript available in the selected language.": "चयनित भाषा में कोई भी ट्रांस्क्रिप्ट उपलब्ध नहीं है",
	"Show {{count}} more": "{{count}} और दिखाएं",
	"Show {{count}} more_plural": "{{count}} और दिखाएं"
};


//////////////////
// WEBPACK FOOTER
// ./locale/hi.json
// module id = ./locale/hi.json
// module chunks = 0 1